var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 5.975-9.105 8c-.068.061-.154.09-.228.14v7.678a.663.663 0 0 0 .667.664h5.333a.67.67 0 0 0 .667-.664v-5.314a.663.663 0 0 1 .666-.665h4a.67.67 0 0 1 .667.665v5.314a.663.663 0 0 0 .667.664h5.333a.67.67 0 0 0 .666-.664v-7.677c-.07-.048-.155-.075-.219-.133zM23.78 11.01 13.115 1.627a1.664 1.664 0 0 0-2.227 0L.22 11.01a.664.664 0 0 0-.05.938l.892.99a.667.667 0 0 0 .942.05l9.554-8.399a.67.67 0 0 1 .882 0l9.555 8.398a.666.666 0 0 0 .942-.05l.892-.99a.663.663 0 0 0-.051-.937"
  })));
};
export default SvgHome;